import { CurrenciesAllowedEnum, CurrencyAmountSchema, type CurrencyAmountType } from "@tutellus/core-contracts-ifaces"
import { formatCurrencyAmount } from "../../js/number"

export class CurrencyAmount {
  constructor(
    private readonly _number: number,
    private readonly _currencyID: CurrenciesAllowedEnum,
  ) {}

  static create({ number, currencyID }: CurrencyAmountType) {
    CurrencyAmountSchema.parse({ number, currencyID })
    return new CurrencyAmount(number, currencyID as CurrenciesAllowedEnum)
  }

  get number() { return this._number } // prettier-ignore
  get currencyID() { return this._currencyID } // prettier-ignore
  get formatted() {
    return formatCurrencyAmount({
      number: this.number,
      currencyID: this.currencyID,
    })
  }

  serialize() {
    return {
      number: this.number,
      currencyID: this.currencyID,
      formatted: this.formatted,
    }
  }
}

export type CurrencyAmountSerialized = ReturnType<CurrencyAmount["serialize"]>
